import { SingleSignatureStatus } from './SingleSignatureStatus.model';
export default interface ICarePlanSignatureStatus {
    ProviderSignature: SingleSignatureStatus;
    MemberSignature: SingleSignatureStatus;
}

export class CarePlanSignatureStatus implements ICarePlanSignatureStatus {
    ProviderSignature: SingleSignatureStatus;
    MemberSignature: SingleSignatureStatus;

    constructor() {
        this.ProviderSignature = new SingleSignatureStatus();
        this.MemberSignature = new SingleSignatureStatus();
    }
}
